module.exports = __webpack_public_path__ + "img/symbol_7.d08e5494.png";